import "./Style.scss";
import CustomModal from "./CustomModal";
import ConfirmationModal from "./ConfirmationModal";
import InformationModal from "./InformationModal";

export { CustomModal, ConfirmationModal, InformationModal };
